export const markNotificationsAsReadBulkActionType = 'markNotificationsAsRead';
